import { isEmpty } from 'lodash'

//Hack to format achievements for now until bnackend can get to it
export function formatAchievementsResponse(achievementsArray) {
  let resp = [];
  let hash = {};
  for (let ach of achievementsArray) {
    if (!hash[ach.type]) {
      hash[ach.type] = { type: ach.type, completed: [{ name: ach.name, timesCompleted: ach.timesCompleted }] };

	for(let i=0;i<10;i++){
				hash[ach.type].completed.push({ name: ach.name, timesCompleted: ach.timesCompleted });
	}

      resp.push(hash[ach.type]);
    } else {
      hash[ach.type].completed.push({ name: ach.name, timesCompleted: ach.timesCompleted });
    }
  }
  return resp;

}

export const hasAnswer = (question, questions) => {
    return questions.find((q) => {
        return q.question === question;
    })
}

export const replaceQuestionKey = (questions,question) => {
    return questions.map((q) => {
        if(q.question === question.question)
        {
            q.answer = question.answer;
        }
        return q;
    });
}

export const findQuestion = (question, questions) => {
    let found = (!isEmpty(questions)) ? hasAnswer(question,questions): false;

    if(!found)
    {
        return {
            answer: null
        }
    }

    return found;
}